import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import type { FC } from 'react'
import { t } from 'ttag'

const ListSearch: FC<{
  searchText: string
  handleSearchTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSearch: () => void
  placeholder: string
  helperText?: string
  sx?: object
}> = ({ searchText, handleSearchTextChange, handleSearch, placeholder, helperText, sx }) => {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      variant="standard"
      helperText={helperText}
      sx={sx}
      value={searchText}
      onChange={handleSearchTextChange}
      onKeyUp={ev => {
        if (ev.key === 'Enter') {
          handleSearch()
          ev.preventDefault()
        }
      }}
      InputProps={{
        sx: { paddingBottom: '2px' },
        startAdornment: (
          <InputAdornment position="start">
            <IconButton
              sx={{ p: '10px' }}
              aria-label={t`Search`}
              onClick={handleSearch}
              edge="start"
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  )
}
export default ListSearch
